<template>
  <div>
    <van-popup v-model="show" round :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <div class="title">重要提示</div>
        <div class="text">
          <div class="money-tips" v-if="availableBalance > 0">您的“银联待提现金额”余额＞0，请先将其提现后再进行“保证金提现”，否则将与“保证金”一起进行提现申请</div>
          <div>发起申请提现后，您所在的账号将无法继续在“拓客宝”系统中使用。请谨慎申请提现！</div>
          <div class="tips-box">
            <span class="tips">保证金提现说明</span>
            1、保证金提现需发起提现申请，公司相关人员会进行审核，审核通过后，即可将“保证金”全额打至“银联商户号”。审核周期不定，最长不超过半年；<br />
            <span class="special">2、发起“申请提现”后，您所在的账号将无法继续在“拓客宝”系统中使用。请谨慎申请提现！</span>
          </div>
        </div>
        <div class="footer">
          <div class="btn" @click="show = false">取消</div>
          <div class="btn active" @click="withdraw">确定提现</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
  import _ from 'loadsh'
  export default {
    props: {
      availableBalance: {
        type: Number,
        default: 0,
      }
    },
    data() {
      return {
        show: false,
        debounceFn: _.debounce(this.frozenMarginWithdrawApply,100)
      }
    },
    methods: {
      open() {
        this.show = true
      },
      withdraw() {
        this.debounceFn()
      },
      frozenMarginWithdrawApply() {
        const toast = this.$toast.loading({
          duration: 0, 
          forbidClick: true,
          message: '加载中...',
        });
        this.$api.withdrawal.frozenMarginWithdrawApply().then(res => {
          if (res.success) {
           setTimeout( async () => {
              this.$toast('提现申请成功！')
              // await this.$api.h5.unBinding()
              // this.$router.push({
              //   path: '/binding',  
              // })
           },500)
            this.show = false
          }
        }).finally(() => {
          toast.clear()
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .content {
    width: 72vw;
    padding: 20px;
    color: #333333;
    .title {
      color: #333333;
      font-size: 17px;
      text-align: center;
      margin-bottom: 15px;
    }
    .money-tips {
      margin-bottom: 10px;
    }
    .tips-box {
      margin-top: 10px;
      .tips {
        display: block;
        margin-bottom: 4px;
      }
      .special {
        font-weight: bold;
        color: red;
      }
    }
    .footer {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 38px;
        color: #666666;
        font-size: 17px;
        background: #E5E5E5;
        border-radius: 4px;
      }
      .active {
        color: #fff;
        background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
      }
    }
  }
</style>